import { render, staticRenderFns } from "./ProjectTaskDefaultsForm.vue?vue&type=template&id=659b0274&"
import script from "./ProjectTaskDefaultsForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectTaskDefaultsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports